import ButtonsStep from "./buttons-step";

import image1 from '../assets/shop.svg';
import image1hover from '../assets/shop-hover.svg';
import image2 from '../assets/business-and-trade.svg';
import image2hover from '../assets/business-and-trade-hover.svg';
import image3 from '../assets/corporation.svg';
import image3hover from '../assets/corporation-hover.svg';
import image4 from '../assets/partnership.svg';
import image4hover from '../assets/partnership-hover.svg';
import image5 from '../assets/non-profit.svg';
import image5hover from '../assets/non-profit-hover.svg';
import image6 from '../assets/other.svg';
import image6hover from '../assets/other-hover.svg';

function Step2() {
    const stepTitle = `What type of business do you run?`;

    const stepElements = [
        {
            "text": "Sole proprietorship",
            "image": image1,
            "imageHover": image1hover,
            "value": 1
        },
        {
            "text": "Limited liability company (LLC)",
            "image": image2,
            "imageHover": image2hover,
            "value": 2
        },
        {
            "text": "Corporation",
            "image": image3,
            "imageHover": image3hover,
            "value": 3
        },
        {
            "text": "Partnership",
            "image": image4,
            "imageHover": image4hover,
            "value": 4
        },
        {
            "text": "Non-profit",
            "image": image5,
            "imageHover": image5hover,
            "value": 5
        },
        {
            "text": "Other",
            "image": image6,
            "imageHover": image6hover,
            "value": 6
        },
    ];

    return (
        <>
            <h3 className='h2 fw-normal mb-5 text-center'>{stepTitle}</h3>
            <ButtonsStep stepElements={stepElements} stepTitle={stepTitle}></ButtonsStep>
        </>
    );
}

export default Step2;